import type { IModuleState } from '../state/interface';
import type { IModuleDialog } from './dialog';

const onDecline = (deps: { store: IModuleState; dialog: IModuleDialog }) => {
    deps.store.action.hideProgressBar();
    deps.dialog.hide();
};

export default onDecline;
